module.exports = __webpack_public_path__ + "media/images/siwa/apple_left_black_logo_m-95ec29ca5784cf764087a45ea7adb7f3.svg";